// extracted by mini-css-extract-plugin
export var text = "BreadCrumb-module--text--2NtlE";
export var defaultCursor = "BreadCrumb-module--defaultCursor--1IDnF";
export var grey = "BreadCrumb-module--grey--12rz8";